module.exports = __webpack_public_path__ + "static/media/banner-assinatura-anual-mobile.a47d1d56.jpg";